import { lazyWithSuspense } from '~/utilities/lazyWithSuspense';
import { LoadingState } from './LoadingState';

export const Activation = lazyWithSuspense(async () => import('./ActivationScreen'), {
  loadingState: <LoadingState />,
  exportKey: 'ActivationScreen',
});
